import RestClient from './rest-client'

export default class CreditCard extends RestClient {
  static get url () {
    return this.apiUrl + '/credit_cards'
  }

  static get paramKey () {
    return 'credit_card'
  }

  async addFunds (params = {}) {
    const { data } = await this.constructor._post(this.constructor.url + `/${this.id}/add_funds`, {
      credit_card: params
    })

    return data.data
  }
}
